'use client';
import classNames from 'classnames';
import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import { isH5HandleClient } from 'eco-design-micro/utils-base/isH5Handle';
import EcoImgVideo from 'eco-design/base/eco-img-video';
import { useEffect, useState } from 'react';
import { Autoplay, Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import './index.scss';
import EcoLink from 'eco-design/base/eco-link';

export const SwiperArrow = (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
        <path
            d="M6.56019 12.5836L1.05065 7.07409C0.871663 6.8951 0.871663 6.6049 1.05065 6.42591L6.56019 0.916369"
            stroke="currentColor"
            strokeWidth="1.83333"
            strokeLinecap="round"
        />
    </svg>
);

export default function Content({ id, data = {}, initIndex = 0 }: ContentServerProps) {
    const { title, desc, list = [], isAutoplay, theme } = data;
    const prefixCls = 'index-swiper-a1';

    const [isH5, setIsH5] = useState(false);
    useEffect(() => {
        setIsH5(isH5HandleClient());
    }, []);

    return (
        <GloLayout className={`editor-index-swiper-a1 editor-index-swiper-a1-${theme}`} id={id} data={data}>
            <div className={`index-swiper-a1-info `}>
                <h2 className={`${prefixCls}-title`}>{title}</h2>
                <p className={`${prefixCls}-desc`}>{desc}</p>
            </div>
            <Swiper
                className={`${prefixCls}-swiper ${isAutoplay ? '' : 'no-autoplay'}`}
                initialSlide={initIndex}
                loop
                autoplay={isAutoplay ? { delay: 3000, disableOnInteraction: false } : false}
                pagination={isH5 ? { clickable: true } : false}
                navigation={{
                    nextEl: `.${prefixCls}-control .swiper-button-next`,
                    prevEl: `.${prefixCls}-control .swiper-button-prev`,
                }}
                modules={[Navigation, Pagination, Autoplay]}
                spaceBetween={isH5 ? 24 : 12}
                centeredSlides
                speed={1000}
                slidesPerView="auto"
                key={isAutoplay ? 'autoplay-true' : 'autoplay-false'}
            >
                {list.map((item: any, index: number) => {
                    const { label, title, desc, theme = 'white', lHref, lBtnContent } = item;
                    const itemClasses = classNames({
                        [`${prefixCls}-item`]: true,
                        [`${prefixCls}-item-${index + 1}`]: true,
                        [`${prefixCls}-theme-${theme}`]: theme,
                    });
                    return (
                        <SwiperSlide className={itemClasses} key={index}>
                            <div className={`${prefixCls}-item-img`}>
                                <EcoImgVideo isVideo={item.isVideo} pc={item.pc} h5={item.h5} />
                            </div>
                            <div className={`${prefixCls}-item-msg`}>
                                <div className={`${prefixCls}-item-info`}>
                                    {label && <div className={`${prefixCls}-item-label`}>{label}</div>}
                                    {title && <div className={`${prefixCls}-item-title`}>{title}</div>}
                                    {desc && <div className={`${prefixCls}-item-desc`}>{desc}</div>}
                                </div>
                                {lBtnContent && (
                                    <EcoLink className={`${prefixCls}-item-btn`} href={lHref}>
                                        {lBtnContent}
                                    </EcoLink>
                                )}
                            </div>
                        </SwiperSlide>
                    );
                })}
                <div className={`${prefixCls}-control`}>
                    <div className={`swiper-button-prev`}>{SwiperArrow}</div>
                    <div className={`swiper-button-next`}>{SwiperArrow}</div>
                </div>
            </Swiper>
        </GloLayout>
    );
}
